import React, { useCallback, useEffect, useState } from 'react';
import {
  deletePayrollDiscount,
  fetchPayrollDiscounts,
  savePayrollDiscount,
  setPayrollDiscountDeduction,
} from '../../services/adminService';

const NominaDescuentos = ({ sessionId, onSalir }) => {
  const [descripcion, setDescripcion] = useState('');
  const [descuenta, setDescuenta] = useState('');
  const [lista, setLista] = useState([]);
  const [cargando, setCargando] = useState(true);
  const [guardando, setGuardando] = useState(false);
  const [eliminandoId, setEliminandoId] = useState(0);
  const [error, setError] = useState('');
  const [aviso, setAviso] = useState('');

  const cargar = useCallback(() => {
    setCargando(true);
    setError('');

    return fetchPayrollDiscounts(sessionId)
      .then((items) => {
        setLista(items);
      })
      .catch((requestError) => {
        setLista([]);
        setError(requestError.message || 'No se pudieron cargar los tipos de descuento.');
      })
      .finally(() => {
        setCargando(false);
      });
  }, [sessionId]);

  useEffect(() => {
    cargar();
  }, [cargar]);

  const agregar = (event) => {
    event.preventDefault();
    const texto = descripcion.trim();

    if (!texto) {
      setError('Indica la descripción del tipo de descuento.');
      setAviso('');
      return;
    }

    if (descuenta !== '0' && descuenta !== '1') {
      setError('Indica si este tipo descuenta o no.');
      setAviso('');
      return;
    }

    setGuardando(true);
    setError('');
    setAviso('');

    savePayrollDiscount(sessionId, texto, descuenta)
      .then((items) => {
        setLista(items);
        setDescripcion('');
        setDescuenta('');
        setAviso('Tipo de descuento agregado.');
      })
      .catch((requestError) => {
        setError(requestError.message || 'No se pudo agregar el tipo de descuento.');
      })
      .finally(() => {
        setGuardando(false);
      });
  };

  const marcar = (id, valor) => {
    setError('');
    setAviso('');

    setPayrollDiscountDeduction(sessionId, id, valor)
      .then((items) => {
        setLista(items);
        setAviso('Tipo de descuento actualizado.');
      })
      .catch((requestError) => {
        setError(requestError.message || 'No se pudo actualizar si descuenta.');
      });
  };

  const eliminar = (id) => {
    setEliminandoId(id);
    setError('');
    setAviso('');

    deletePayrollDiscount(sessionId, id)
      .then((items) => {
        setLista(items);
        setAviso('Tipo de descuento eliminado.');
      })
      .catch((requestError) => {
        setError(requestError.message || 'No se pudo eliminar el tipo de descuento.');
      })
      .finally(() => {
        setEliminandoId(0);
      });
  };

  return (
    <div>
      {error ? (
        <div className="admin-alert admin-alert--error" role="alert">
          {error}
        </div>
      ) : null}
      {aviso ? (
        <div className="admin-alert admin-alert--success" role="status">
          {aviso}
        </div>
      ) : null}
      <form className="nomina-descuentos-alta" onSubmit={agregar}>
        <div className="admin-form-row">
          <label className="admin-field">
            <span>Descripción del tipo de descuento</span>
            <input
              value={descripcion}
              maxLength={150}
              autoComplete="off"
              placeholder="Descripción del tipo de descuento"
              onChange={(event) => setDescripcion(event.target.value.toUpperCase())}
            />
          </label>
          <label className="admin-field">
            <span>Descuenta</span>
            <select value={descuenta} onChange={(event) => setDescuenta(event.target.value)}>
              <option value="">Seleccione</option>
              <option value="1">Sí</option>
              <option value="0">No</option>
            </select>
          </label>
        </div>
        <div className="nomina-descuentos-acciones">
          <button type="submit" className="admin-btn admin-btn--primary" disabled={guardando}>
            {guardando ? 'Agregando…' : 'Agregar'}
          </button>
          <button type="button" className="admin-btn admin-btn--secondary" onClick={onSalir}>
            Salir
          </button>
        </div>
      </form>
      {cargando ? <p className="admin-muted">Cargando…</p> : null}
      {!cargando && lista.length === 0 ? <p className="admin-muted">Todavía no hay tipos de descuento.</p> : null}
      {!cargando && lista.length > 0 ? (
        <div className="admin-table-wrap nomina-lista-blanca">
          <table className="admin-table">
            <thead>
              <tr>
                <th>Descripción del descuento</th>
                <th>Descuenta</th>
                <th />
              </tr>
            </thead>
            <tbody>
              {lista.map((item) => (
                <tr key={item.id}>
                  <td>{item.descripcion}</td>
                  <td>
                    <select
                      className="nomina-descuento-marca"
                      value={item.descuenta ? '1' : '0'}
                      onChange={(event) => marcar(item.id, event.target.value)}
                    >
                      <option value="1">Sí</option>
                      <option value="0">No</option>
                    </select>
                  </td>
                  <td>
                    <button
                      type="button"
                      className="admin-btn admin-btn--danger"
                      disabled={eliminandoId === item.id}
                      onClick={() => eliminar(item.id)}
                    >
                      Eliminar
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : null}
    </div>
  );
};

export default NominaDescuentos;
